import { render } from "./CustomerModal.vue?vue&type=template&id=00e2ff1c&scoped=true"
import script from "./CustomerModal.vue?vue&type=script&lang=js"
export * from "./CustomerModal.vue?vue&type=script&lang=js"

import "./CustomerModal.vue?vue&type=style&index=0&id=00e2ff1c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e2ff1c"]])

export default __exports__